import { render, staticRenderFns } from "./TgDecimal.vue?vue&type=template&id=6f2134e0"
import script from "./TgDecimal.vue?vue&type=script&lang=js"
export * from "./TgDecimal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports